import { Button } from "@svea/design-system-components-react";
import { Form } from "react-final-form";
import { useText } from "../../hooks";
import type { Country } from "../../types/country";
import type { QuestionnaireFormValues } from "../../types/form";
import type { AnyQuestion } from "../../types/question";
import { ButtonGroup } from "../button-group";
import { Stack } from "../stack";
import { Question } from "./question";

type Props = {
	questions: Array<AnyQuestion>;
	onSubmit: (values: QuestionnaireFormValues) => void | Promise<void>;
	initialValues?: QuestionnaireFormValues;
	allCountries: Array<Country>;
};

export const Questionnaire = ({ questions, onSubmit, initialValues, allCountries }: Props) => {
	const [t, texts] = useText();

	return (
		<Form<QuestionnaireFormValues>
			onSubmit={(values) => {
				return onSubmit(values);
			}}
			initialValues={initialValues}
			render={({ handleSubmit, submitting }) => (
				<form onSubmit={handleSubmit}>
					<Stack gap={6}>
						{questions.map((q) => (
							<Question question={q} key={q.questionId} allCountries={allCountries} />
						))}
						<ButtonGroup row align="start">
							<Button type="submit" isPending={submitting}>
								{t(texts.common.save)}
							</Button>
						</ButtonGroup>
					</Stack>
				</form>
			)}
		/>
	);
};
